import React from 'react'

/**
 * This function `fixedForwardRef` solves the problem of using `React.forwardRef`
 * with generic components in TypeScript, where TypeScript loses the generic
 * type information and fails to properly infer props and ref types.
 * @link https://www.totaltypescript.com/forwardref-with-generic-components
 */
export function fixedForwardRef<T, P = NonNullable<unknown>>(
  render: (props: P, ref: React.Ref<T>) => React.ReactNode,
): (props: P & React.RefAttributes<T>) => React.ReactNode {
  return React.forwardRef(render) as TSFixMe
}
